import { useFetcher } from "@remix-run/react"
import { type FC } from "react"

interface ContentAgreementModalProps {
	onAgreed: () => void
	onCancel: () => void
}

const rules = [
	"All content you share is public and visible to the community.",
	"No NSFW, offensive, or inappropriate content.",
	"Be respectful and constructive in your interactions.",
	"No spam, self-promotion, or repeated low-effort posts.",
	"Content that violates these guidelines may be removed.",
	"Repeated violations may result in losing the ability to post.",
]

const ContentAgreementModal: FC<ContentAgreementModalProps> = ({ onAgreed, onCancel }) => {
	const fetcher = useFetcher<{ success?: boolean }>()
	const isSubmitting = fetcher.state === "submitting"

	const handleAgree = () => {
		fetcher.submit(
			{},
			{ method: "POST", action: "/resources/content-agreement" },
		)
		onAgreed()
	}

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center p-4">
			<div
				className="fixed inset-0 bg-black/50"
				onClick={onCancel}
			/>
			<div className="relative z-10 w-full max-w-md rounded-xl border bg-background p-6 shadow-lg">
				<h3 className="text-lg font-semibold">Community Guidelines</h3>
				<p className="mt-2 text-sm text-muted-foreground">
					Before posting, please review and agree to our community guidelines:
				</p>

				<ul className="mt-4 space-y-2">
					{rules.map((rule, i) => (
						<li key={i} className="flex gap-2 text-sm">
							<span className="shrink-0 text-primary">&#x2022;</span>
							<span>{rule}</span>
						</li>
					))}
				</ul>

				<div className="mt-6 flex justify-end gap-3">
					<button
						onClick={onCancel}
						className="rounded-md border border-input px-4 py-2 text-sm font-medium hover:bg-muted"
					>
						Cancel
					</button>
					<button
						onClick={handleAgree}
						disabled={isSubmitting}
						className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 disabled:opacity-50"
					>
						{isSubmitting ? "Saving..." : "I Agree"}
					</button>
				</div>
			</div>
		</div>
	)
}

export default ContentAgreementModal
